import React, { useEffect, useState } from 'react';
import { motion, useScroll } from 'framer-motion';
export function FloatingCTA() {
  const {
    scrollY
  } = useScroll();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    return scrollY.onChange(latest => {
      if (latest > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    });
  }, [scrollY]);
  return <motion.div initial={{
    y: 100
  }} animate={{
    y: isVisible ? 0 : 100
  }} transition={{
    duration: 0.3
  }} className="fixed bottom-0 left-0 right-0 z-50 bg-[#0a0a0a]/90 backdrop-blur-md border-t border-[#222] p-4 md:hidden" data-id="element-8">
      <div className="flex items-center justify-between max-w-md mx-auto" data-id="element-9">
        <div className="flex flex-col" data-id="element-10">
          <span className="text-[#f5f0e8] font-serif font-bold" data-id="element-11">$6.39 USD</span>
          <span className="text-[10px] text-[#8a8578] uppercase tracking-wider" data-id="element-12">
            Trading en Paz
          </span>
        </div>
        <a href="https://pay.hotmart.com/I104339970M" target="_blank" rel="noopener noreferrer" className="px-6 py-2 bg-gradient-to-r from-[#b8942e] to-[#e8c84a] text-black font-bold text-sm rounded shadow-lg shadow-yellow-900/20" data-id="element-13">
          CONSEGUIR
        </a>
      </div>
    </motion.div>;
}